/**
 * Application-wide constants. No magic strings allowed — all string literals
 * used across packages MUST be defined here or in a sibling constants file.
 */
export const APP_NAME = 'WillDesign Work Tracker';
export const APP_VERSION = '0.1.0';
export const STAGES = {
    LOCAL: 'local',
    STAGING: 'staging',
    PRODUCTION: 'production',
};
export const DYNAMO_TABLE_PREFIX = {
    [STAGES.STAGING]: 'worktracker-staging',
    [STAGES.PRODUCTION]: 'worktracker-prod',
};
export const S3_BUCKET_PREFIX = {
    [STAGES.STAGING]: 'worktracker-staging-site',
    [STAGES.PRODUCTION]: 'worktracker-prod-site',
};
export const DOMAINS = {
    [STAGES.STAGING]: 'work-tracker.staging.wilreji.com',
    [STAGES.PRODUCTION]: 'work-tracker.wilreji.com',
};
export const AWS_REGION = 'ap-southeast-1';
export const AWS_EDGE_REGION = 'us-east-1';
export const AWS_ACCOUNT_ID = '149536467343';
export const SESSION_TTL_SECONDS = 7 * 24 * 60 * 60; // 7 days
export const PERMISSION_CACHE_TTL_SECONDS = 5 * 60; // 5 minutes
export const GITHUB_ORG = 'WiLLDesignTech';
export const SSO_DOMAINS = {
    [STAGES.LOCAL]: 'localhost:3001',
    [STAGES.STAGING]: 'sso.staging.wilreji.com',
    [STAGES.PRODUCTION]: 'sso.wilreji.com',
};
export const SSO_APP_ID = 'work-tracker';
export const COOKIE_DOMAINS = {
    [STAGES.LOCAL]: 'localhost',
    [STAGES.STAGING]: '.staging.wilreji.com',
    [STAGES.PRODUCTION]: '.wilreji.com',
};
export const SLACK_CHANNELS = {
    DAILY_REPORTS: '#daily-reports',
    MANAGER_NOTIFICATIONS: '#manager-notifications',
};
export const STANDUP_TIME = {
    HOUR: 7,
    MINUTE: 15,
    TIMEZONE: 'Asia/Kathmandu',
};
export const MAX_FILE_LINES = 500;
export const MAX_CONCURRENT_USERS = 500;
export const MAX_TOTAL_EMPLOYEES = 1000;
//# sourceMappingURL=app.js.map